/**
 * DNH — PWA Splash Screen
 * Shows only in standalone (home-screen) mode, once per session.
 * Fades out after 1.8 s so the shell has time to render behind it.
 */
import React, { useEffect, useState } from "react";

const isStandalone = () =>
  window.navigator.standalone === true ||
  window.matchMedia("(display-mode: standalone)").matches;

export default function SplashScreen() {
  const [visible, setVisible] = useState(false);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (!isStandalone()) return;
    if (sessionStorage.getItem("dnh_splash_shown")) return;
    sessionStorage.setItem("dnh_splash_shown", "1");
    setVisible(true);
    const fadeTimer = setTimeout(() => setFading(true), 1600);
    const hideTimer = setTimeout(() => setVisible(false), 2200);
    return () => { clearTimeout(fadeTimer); clearTimeout(hideTimer); };
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="pwa-splash-screen"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        backgroundColor: "#0e0e0e",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
        transition: "opacity 0.55s ease",
        opacity: fading ? 0 : 1,
        paddingTop: "env(safe-area-inset-top)",
      }}
    >
      <img
        src="/dnh-logo.svg"
        alt="Daily News Highlights"
        style={{ width: 88, height: 88, objectFit: "contain" }}
        onError={(e) => { e.target.src = "/icon-192.png"; }}
      />
      <div style={{ textAlign: "center" }}>
        <p style={{
          fontFamily: "Georgia, serif",
          fontSize: 22,
          fontWeight: 600,
          color: "#f5f0e8",
          letterSpacing: "0.01em",
          margin: 0,
        }}>
          Daily News Highlights
        </p>
        <p style={{
          fontFamily: "monospace",
          fontSize: 11,
          color: "#888",
          letterSpacing: "0.12em",
          textTransform: "uppercase",
          marginTop: 6,
        }}>
          Global Intelligence
        </p>
      </div>
    </div>
  );
}
